module.exports = __webpack_public_path__ + "static/media/IMG_20201012_234137_413_tn.791768cc.jpg";